import { render, staticRenderFns } from "./MentorRegistration.vue?vue&type=template&id=d76b8b40&"
import script from "./MentorRegistration.vue?vue&type=script&lang=js&"
export * from "./MentorRegistration.vue?vue&type=script&lang=js&"
import style0 from "./MentorRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports